import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { DepositMethodsEnum } from '@hub-workspace/apps/logged-home/src/app/shared/enums/deposit-methods.enum';
import { DialogDepositComponent } from '../../dialog-deposit/dialog-deposit.component';
import { ModalComponent } from '@toro/common/shared/components/modal/modal.component';
import { UserReRegistationService } from '@toro/common/shared/services/re-registration/user-re-registration.service';
import { IReRegistrationMessage } from '@toro/common/shared/interfaces/re-registration/re-resgistration.interface';
import { PixDepositService } from '../../../services/pix-deposit/pix-deposit.service';
import { getFirstWord } from '@toro/common/shared/resources/profile.utils';
import { isCnpj } from '@toro/common/shared/helpers/utils/document';
enum PixButtonState {
  Loading,
  Visible,
  Hidden
}

@Component({
    selector: "open-account-transfer",
    templateUrl: "./open-account-transfer.component.html",
    styleUrls: ["./open-account-transfer.component.scss"]
})
export class OpenAccountTransferComponent implements OnInit {
    @ViewChild("modalUserRegister", { static: true })
    public modalUserRegister: ModalComponent;
    @Input() userAuth: any;
    @Input() user: any;
    public modalUserReRegistration: IReRegistrationMessage;
    pixButtonState: PixButtonState;

    constructor(
        private dialogsService: DialogsService,
        private store: Store<any>,
        private userReRegistationService: UserReRegistationService,
        private pixDepositService: PixDepositService
    ) {
      this.pixButtonState = PixButtonState.Loading;
      this.checkPixEnabled();
    }
    ngOnInit(): void {
        this.getUserRegistrationStore();
    }

    public get profile(): any {
        return (this.user && this.user.user) || {};
    }

    public get accessedByFullName(): string {
        const currentUserName = this.userAuth && this.userAuth.currentUser && this.userAuth.currentUser.name;
        return this.profile.representativeName || currentUserName || '';
    }

    public get accessedByName(): string {
        return getFirstWord(this.accessedByFullName);
    }

    public get isPJRepresentation(): boolean {
        return this.profile.isRepresentation === true;
    }

    /**
     * Indica se a conta logada e Pessoa Juridica (documento com mais de 11 digitos = CNPJ)
     */
    public get isPj(): boolean {
        return isCnpj(this.profile.cpfcnpj);
    }

    public openDepositModal(depositCategory: string) {
        this.dialogsService.showComponentAsAsidePanel(
            DialogDepositComponent,
            true,
            {
                category: depositCategory,
                user: this.user,
                userAuth: this.userAuth,
            }
        );

        if (depositCategory === DepositMethodsEnum.Pix) {
            const events = {
                'Product Area Origin': 'Conta aberta',
                'Time Responsável': "Roebling",
                'Element': 'Botão depósito via Pix',
                'Text': 'Depósito via Pix Copia e Cola',
            };
            this.sendTracking("Element Clicked", events);
        } else if(depositCategory === DepositMethodsEnum.Ted) {
            const events = {
                'Product Area Origin': 'Conta aberta',
                'Time Responsável': "Roebling",
                'Element': 'Botão depósito via TED',
                'Text': 'Depósito via TED',
            };
            this.sendTracking("Element Clicked", events);
        }
    }

    public showUserAccount() {
        if (!this.user || !this.userAuth) return false;

        return this.user.user.cpfcnpj && this.userAuth.currentUser.cblc;
    }

    public sendTracking(event: string, breakdowns: any) {
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: { type: event, events: breakdowns },
        });
    }

    /**
     * Busca os registros status do usuário
     */
    private getUserRegistrationStore() {
      this.store
        .select(({ userProfile }) => userProfile)
        //   .pipe(take(2))
        .subscribe((up) => {
          if (!up.user || !+up.user.registrationStatus) {
            return;
          }
          this.verifyUserReRegister(+up.user.registrationStatus);
        });
    }

    /**
     * verifica se usuário esta expirado
     * Expired = 15
     * PreExpirado = 18
     */
    private verifyUserReRegister(registrationStatus: number) {
      const userExpired = this.userReRegistationService.validateUserExpired(
        registrationStatus
      );
      if (userExpired) {
        this.modalUserReRegistration = userExpired;
        this.modalUserRegister.show();
        return;
      }

      const userPreExpired = this.userReRegistationService.validateUserPreExpired(
        registrationStatus
      );
      if (userPreExpired) {
        this.modalUserReRegistration = userPreExpired;
        this.modalUserRegister.show();
        return;
      }
    }

    public checkPixEnabled() {
      this.pixDepositService
        .getDepositByPixEnabled()
        .then(remoteConfigValue => {
          this.pixButtonState = remoteConfigValue
            ? PixButtonState.Visible
            : PixButtonState.Hidden;
        })
        .catch(err => {
          console.error(err);
          this.pixButtonState = PixButtonState.Hidden;
        });
    }

    public isPixLoading() {
      return this.pixButtonState == PixButtonState.Loading;
    }

    public isPixVisible() {
      return this.pixButtonState == PixButtonState.Visible && !this.isPj;
    }

    public isPixEnabled() {
      return this.isPixVisible() && this.showUserAccount();
    }
}
